import { render, staticRenderFns } from "./PageSkeletonTwo.vue?vue&type=template&id=2a4e97b6&scoped=true"
import script from "./PageSkeletonTwo.vue?vue&type=script&lang=js"
export * from "./PageSkeletonTwo.vue?vue&type=script&lang=js"
import style0 from "./PageSkeletonTwo.vue?vue&type=style&index=0&id=2a4e97b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e97b6",
  null
  
)

export default component.exports